import type { FC, ReactNode } from "react";
import classnames from "classnames";
import styles from "../MatchPrediction.module.scss";
import useTranslation from "next-translate/useTranslation";
import Trans from "next-translate/Trans";

interface BasedPredictionWrapperProps {
  totalPredictions: number;
  isPredictionAllowed: boolean;
  children: ReactNode;
}

export const BasedPredictionWrapper: FC<BasedPredictionWrapperProps> = (
  props,
): JSX.Element => {
  const { totalPredictions, isPredictionAllowed, children } = props;
  const { t } = useTranslation("web-payments");

  return (
    <>
      <p className={classnames("title-7-regular", styles.message)}>
        {isPredictionAllowed ? (
          <Trans
            i18nKey="web-payments:MATCH_PREDICTION_COUNT_MESSAGE"
            components={{
              b: <b>{totalPredictions}</b>,
            }}
          />
        ) : (
          t("MATCH_PREDICTION_MAKE_PREDICTION")
        )}
      </p>
      {children}
    </>
  );
};
